import React from "react";
import moment from "moment";
import context from "../../lib/context.js";
import {Link} from "react-router";

export default class TimecardListItem extends React.Component {
    constructor(props) {
        super(props);
        this.getLink = this.getLink.bind(this);
    }   

    getLink(vm) {
        if (vm.timecardSummary.timecardType === "DURATIONTC") {
             return context.routeUrl(`${this.props.role}/tc-duration/${vm.timecardSummary.timecardId}`);
            // let submitted = vm.timecardSummary.statusCode === "Submitted" ? 1 : 0;            
            // return context.url("..","People",`TimeSheet.aspx?tid=${vm.tId}&oid=${vm.timecardSummary.offsysId}` + 
            //     `&pid=${vm.timecardSummary.placementId}&ppid=${vm.ppId}&role=${vm.role}&submitted=${submitted}`);
        } else {            
            return context.routeUrl(`${this.props.role}/tc-clock-edit/${vm.timecardSummary.timecardId}`);
            //return context.url("..","People",`TimeClockEntry.aspx?token=${vm.token}`);
        }
    }

    render() {
        let vm = this.props.vm;            
        let tc = vm.timecardSummary;
        let verifiedClassName = "fa fa-calendar-check-o ap-blue-color " + (tc.statusCode.toLowerCase() == "approved" ? "" : "ap-hidden");
        let editedClassName = "glyphicon glyphicon-edit ap-error-color " + (tc.isEdited ? "" : "ap-hidden");    
        let incompleteClassName = "fa fa-calendar-times-o ap-error-color " + (tc.isIncomplete ? "" : "ap-hidden");
        let unapprovedPtoClassName = "fa fa-suitcase ap-error-color " + (tc.hasUnapprovedPto ? "" : "ap-hidden");
        let nonExemptClassName = "glyphicon glyphicon-check ap-good-color " + (tc.exemptType === "NONEXEMPT" ? "" : "ap-hidden");        
        let totalClassName = tc.totalHour < tc.weeklyHours ? "ap-error-color ap-total-hour" : "ap-total-hour";
        let chkBoxClassName= tc.isIncomplete || tc.isEdited || tc.hasUnapprovedPto ? "ap-hidden" : "";
        return(                        
            <div className="row ap-timecard-list-item">
                <section className="hidden-sm hidden-xs">
                    <div className="col-md-1 col-lg-1 ap-pr-0">
                        <input className={chkBoxClassName} type="checkbox" 
                        checked={tc.isChecked === true} 
                        onChange={() => this.props.onChecked(tc.timecardId)}/>                    
                        <div className="ap-icon pull-right">
                            { incompleteClassName.indexOf("hidden") > -1?
                                <span className={verifiedClassName} title="Pre-Verified"/> 
                            :
                                <i className={incompleteClassName} title="Incomplete"></i> }
                        </div>
                        <div className="ap-icon pull-right">
                           <span className={editedClassName} title="Edited"/>
                        </div>
                        <div className="ap-icon pull-right">
                            <span className={nonExemptClassName} title="Non-Exempt"/>
                        </div>
                        <div className="ap-icon pull-right">
                            <span className={unapprovedPtoClassName} title="Unapproved Time-Off"/>
                        </div>
                    </div>
                    <div className="col-md-2 col-lg-2">
                        <Link to={this.getLink(vm)} activeClassName="ap-person-name" title={`#${tc.timecardId},${tc.statusCode}`}>{tc.peopleName}</Link>        
                    </div>
                    <div className="col-md-2 col-lg-2 ap-color-darkgray">
                        {tc.reportToName}
                    </div>
                    <div className="col-md-1 col-lg-1 ap-color-darkgray">
                        {tc.placementId}
                    </div>
                    <div className="col-md-1 col-lg-1 ap-color-darkgray">
                        {moment(tc.weekEnding).format("MM/DD/YYYY")}
                    </div>  
                    <div className="col-md-1 col-lg-1 text-center ap-color-darkgray">
                        {tc.regularHour} : {tc.regularMin}
                    </div>
                    <div className="col-md-1 col-lg-1 text-center ap-color-darkgray">
                       {tc.otHour} : {tc.otMin}
                    </div>
                    <div className="col-md-1 col-lg-1 text-center ap-color-darkgray">
                        {tc.dtHour} : {tc.dtMin}
                    </div>
                    <div className={`col-md-1 col-lg-1 text-center ${tc.hasUnapprovedPto? "ap-error-color" : "ap-color-darkgray"}`}>
                        {tc.miscHour} : {tc.miscMin}
                    </div>  
                    <div className="col-md-1 col-lg-1 ap-color-darkgray">
                        <div className="ap-unwrap-content">                          
                            <span className={totalClassName}>{tc.totalHour} : {tc.totalMin}</span>
                            <span className="ap-color-gray">({tc.weeklyHours})</span>
                        </div>
                    </div>    
                </section>
                <section className="hidden-md hidden-lg"> 
                    <div className="col-xs-6 col-sm-6">
                        <input className={chkBoxClassName} type="checkbox" 
                        checked={tc.isChecked === true} 
                        onChange={() => this.props.onChecked(tc.timecardId)}/>                    
                        <div className="ap-icon">
                            <span className={incompleteClassName} title="Incomplete"/>
                        </div>
                        <div className="ap-icon">
                           <span className={editedClassName} title="Edited"/>
                        </div>
                        <div className="ap-icon">
                            <span className={verifiedClassName} title="Pre-Verified"/>
                        </div>
                        <div className="ap-icon">
                            <span className={nonExemptClassName} title="Non-Exempt"/>
                        </div>
                        <div className="ap-icon">
                            <span className={unapprovedPtoClassName} title="Unapproved Time-Off"/>
                        </div>
                    </div>
                    <div className="col-xs-6 col-sm-6">                        
                        <b>{moment(tc.weekEnding).format("MM/DD/YYYY")}</b>
                    </div>
                    <div className="col-xs-12 col-sm-12">
                        <a href={this.getLink(vm)} className="ap-person-name" title={`#${tc.timecardId},${tc.statusCode}`}>{tc.peopleName}</a>
                    </div> 
                    <div className="col-xs-12 col-sm-12">
                        <span className="ap-color-gray">Assign ID </span>
                        <b>{tc.placementId}</b>
                    </div>  
                    <div className="col-xs-12 col-sm-12 ap-separator-col">                        
                    </div>
                    <div className="col-xs-6 col-sm-6">
                        <span className="ap-color-gray">Regular Time </span><br/>
                        <b>{tc.regularHour} : {tc.regularMin}</b>
                    </div>
                    <div className="col-xs-6 col-sm-6">
                        <span className="ap-color-gray">Over Time </span><br/>
                        <b>{tc.otHour} : {tc.otMin}</b>
                    </div>
                    <div className="col-xs-12 col-sm-12 ap-separator-col">              
                    </div>
                    <div className="col-xs-6 col-sm-6">
                        <span className="ap-color-gray">Double Time </span><br/>
                        <b>{tc.dtHour} : {tc.dtMin}</b>
                    </div>
                    <div className={`col-xs-6 col-sm-6 ${tc.hasUnapprovedPto? "ap-error-color" : ""}`}>
                        <span className="ap-color-gray">Misc </span><br/>
                        <b>{tc.miscHour} : {tc.miscMin}</b>
                    </div>  
                    <div className="col-xs-12 col-sm-12 ap-separator-col">          
                    </div>
                    <div className="col-xs-12 col-sm-12">
                        <div className="ap-unwrap-content">
                            <span className="ap-color-gray">Total </span><br/>
                            <b className={totalClassName}>{tc.totalHour} : {tc.totalMin}</b>
                            <span>({tc.weeklyHours})</span>
                        </div>
                    </div>  
                </section>
            </div>                           
        );
        
    }
}